import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      gap: 16,
    },
    scrollViewport: {
      padding: 0,
    },
    scrollThumb: {
      display: 'none',
    },
  }
})
